import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { patchAddClient } from '../services/patchAddClient.service';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const addProjectOrganizationChartClientForBusiness = createAsyncThunk(
  'organizationCharts/addProjectOrganizationChartClientForBusiness',
  async ({ targetOrganizationChartItemId, clientBusinessId }, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    const response = await patchAddClient(
      selectedProjectId,
      targetOrganizationChartItemId,
      clientBusinessId,
      activeEmployerInfo
    );

    return response;
  }
);
